import { atom } from 'nanostores';

export const alimSessionValid = atom(false);
export const alimUserRole = atom(null);
export const zamzamSurahs = atom(null);
export const currentSurahNum = atom(null);
export const currentVidId = atom(null);
export const isSidebarLoaded = atom(false);
export const isDarkThemeEnabled = atom(false);
export const translationSettingsStore = atom(null);
export const arabicFontSettingsStore = atom(null);
export const englishFontSettingsStore = atom(null);
export const isMediaPlayerPlaying=atom(false);
export const selectedAdPlansUser=atom(null);
export const isDonationWindowHiddden=atom(false);